import { collection, findSelector, resource } from "data/helpers/apiv3";
import { Event } from "data/records";
import { loadAllPages } from "lib/loadAllPages";

const [api, actions] = resource(Event, [
  ["list", collection.get("", ["userId", "organizationId", "excludePast"])],
  ["create", collection.post("", ["name", "userId"])],
]);
actions.loadAllEvents =
  ({ userId, organizationId, ...params }) =>
  (dispatch) => {
    const loadEventsPage = ({ pageIndex: page, perPage }) =>
      dispatch(actions.list({ userId, organizationId, page, perPage, ...params }));
    const isLastPage = ({ perPage, pageIndex, pageResults }) => {
      return perPage * (pageIndex + 1) >= pageResults.value.totalCount;
    };

    return loadAllPages({
      promiseProducer: loadEventsPage,
      perPage: 100,
      isLastPage,
    });
  };

const selectors = {
  ...findSelector(Event),
  byUserId: (state, userId) => state.apiv3.event.id.filter((e) => e.userId === userId),
};

const reducers = {};

const initialState = {};

export {
  api as eventApi,
  actions as eventActions,
  selectors as eventSelectors,
  reducers as eventReducers,
  initialState as eventInitialState,
};
